export const Kademe = (props) => (
  <a
    href="https://kademe.konya.bel.tr/page/anasayfa"
    aria-label="Kademe Website linki"
    target="_blank"
    rel="noreferrer"
  >
    <svg viewBox="0 0 30.17 22.12" {...props}>
      <g id="Layer_1-2" data-name="Layer 1">
        <g>
          <g>
            <path
              className="cls-1"
              d="M9.15,0h0c.1,0,.19.03.28.09,1.25.77,2.51,1.54,3.76,2.31.13.08.28.15.35.29.14.23.06.57-.17.71-1.32.83-2.63,1.67-3.95,2.5-.24.16-.6.07-.74-.19-.05-.09-.07-.2-.08-.3V.67c.02-.13,0-.26.07-.38.09-.18.28-.29.48-.29Z"
            />
            <g>
              <path
                className="cls-1"
                d="M15.96.03c.09-.03.18,0,.27-.01,1.72,0,3.45,0,5.17,0,.08,0,.17.07.17.15,0,.19,0,.38,0,.57,0,.08-.08.15-.17.14-1.79,0-3.58,0-5.38,0-.09,0-.17-.08-.17-.17,0-.17,0-.35,0-.52,0-.07.03-.14.1-.17Z"
              />
              <path
                className="cls-1"
                d="M18.56,1.21c.21-.05.44.03.56.21.77,1.22,1.55,2.45,2.32,3.67.08.11.14.24.13.38,0,.26-.24.49-.5.49-1.56,0-3.12,0-4.68,0-.18,0-.35-.09-.44-.25-.1-.16-.1-.37,0-.53.76-1.24,1.53-2.49,2.29-3.73.07-.12.19-.21.32-.24Z"
              />
            </g>
            <path
              className="cls-1"
              d="M18.61,7.48c.49-.06,1,.05,1.42.31.68.41,1.11,1.22,1.04,2.01-.06.4-.26.75-.46,1.09-.45.7-1.02,1.31-1.56,1.94-.09.09-.25.09-.34,0-.6-.69-1.23-1.37-1.69-2.16-.16-.3-.32-.62-.33-.96-.01-.51.17-1.03.49-1.42.35-.44.88-.73,1.44-.8Z"
            />
            <path
              className="cls-1"
              d="M8.78,7.75c.09-.07.2-.1.31-.1.25,0,.51,0,.76,0,0,1.69,0,3.37,0,5.06-.25,0-.51,0-.76,0-.11,0-.23-.03-.31-.11-.12-.09-.16-.24-.18-.38v-4.05c0-.16.05-.33.19-.43Z"
            />
            <path
              className="cls-1"
              d="M10.44,7.66c.42,0,.84,0,1.26,0,0,1.69,0,3.37,0,5.06h-1.26c0-1.69,0-3.37,0-5.06Z"
            />
            <path
              className="cls-1"
              d="M12.19,7.66c.27,0,.53,0,.8,0,.24,0,.44.22.45.45,0,1.38,0,2.76,0,4.14,0,.24-.2.46-.44.47-.27,0-.54,0-.8,0v-5.06Z"
            />
          </g>
          <g>
            <path
              className="cls-1"
              d="M4.07,22.07h-1.38c-.06,0-.13-.04-.18-.1l-1-1.24s-.07.03-.1.03h-.19v1.13c0,.1-.08.19-.19.19H.19c-.11,0-.19-.08-.19-.19v-5.76c0-.11.08-.19.19-.19h.83c.1,0,.19.08.19.19v3.29l.1-.12.98-1.21c.04-.06.12-.1.18-.1h1.17c.06,0,.06.04.02.1l-1.35,1.68,1.78,2.21c.04.06.03.1-.02.1Z"
            />
            <path
              className="cls-1"
              d="M25.38,19.14v2.78c0,.08-.07.15-.15.15h-.83c-.08,0-.15-.07-.15-.15v-2.25c0-.4-.33-.72-.72-.72-.26,0-.49.13-.61.34-.05.08-.08.16-.1.25,0,.04-.01.09-.01.13s0,.09.01.13v2.12c0,.08-.07.15-.15.15h-.83c-.08,0-.15-.07-.15-.15v-2.11s.02-.1.02-.15,0-.1-.02-.15c-.07-.33-.36-.58-.71-.58-.4,0-.72.32-.72.72v2.25c0,.08-.07.15-.15.15h-.83c-.08,0-.15-.07-.15-.15v-3.8c0-.08.07-.15.15-.15h.83c.08,0,.15.07.15.15v.2c.28-.21.63-.34,1.01-.34.15,0,.3.02.44.06.32.08.59.26.81.5.08-.1.18-.18.29-.26.27-.19.6-.3.96-.3.17,0,.34.03.5.07.52.16.94.57,1.1,1.09Z"
            />
            <path
              className="cls-1"
              d="M16.27,17.97c-1.12,0-2.04.92-2.04,2.04s.92,2.03,2.04,2.03c.64,0,1.24-.3,1.62-.8l-.72-.54c-.2.26-.52.42-.85.42-.45,0-.84-.29-1-.69h2.79c.07,0,.12-.06.12-.12v-.29h.07c0-1.12-.92-2.04-2.04-2.04ZM16.32,18.98c.43,0,.81.26.98.64h-1.95c.17-.37.54-.64.98-.64Z"
            />
            <path
              className="cls-1"
              d="M28.13,17.97c-1.12,0-2.03.92-2.03,2.04s.92,2.03,2.03,2.03c.64,0,1.24-.3,1.62-.8l-.72-.54c-.2.26-.52.42-.85.42-.45,0-.85-.29-1-.69h2.79c.07,0,.12-.06.12-.12v-.29h.07c0-1.12-.92-2.04-2.04-2.04ZM28.18,18.98c.43,0,.81.26.98.64h-1.95c.17-.37.54-.64.98-.64Z"
            />
            <path
              className="cls-1"
              d="M13.31,15.93h-.76c-.1,0-.18.08-.18.18v2.08c-.28-.14-.59-.21-.92-.21-1.14,0-2.07.93-2.07,2.07s.93,2.07,2.07,2.07c.33,0,.64-.08.92-.21.01.09.09.16.18.16h.76c.1,0,.18-.08.18-.18v-5.77c0-.1-.08-.18-.18-.18ZM11.45,21.11c-.59,0-1.07-.48-1.07-1.07s.48-1.07,1.07-1.07c.39,0,.73.21.92.52.1.16.15.35.15.55s-.05.39-.15.54c-.18.31-.53.52-.92.52Z"
            />
            <path
              className="cls-1"
              d="M8.45,17.98h-.82c-.08,0-.15.07-.15.15v.03c-.26-.12-.55-.19-.85-.19-1.14,0-2.07.93-2.07,2.07s.93,2.07,2.07,2.07c.3,0,.59-.07.85-.19,0,.08.07.13.15.13h.82c.08,0,.15-.07.15-.15v-3.79c0-.08-.07-.15-.15-.15ZM7.48,20.69c-.2.26-.5.42-.85.42-.59,0-1.07-.48-1.07-1.07s.48-1.07,1.07-1.07c.35,0,.66.17.85.42.14.18.22.4.22.65s-.08.47-.22.64Z"
            />
          </g>
        </g>
      </g>
    </svg>
  </a>
);
